import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function LinksIMC() {
  const isMobile = window.innerWidth < 600;

  const data = {
    labels: ["😟 Abaixo do peso", "🙂 Peso normal", "😐 Sobrepeso", "😰 Obesidade"],
    datasets: [
      {
        label: "Distribuição (%)",
        data: [10, 45, 30, 20],
        backgroundColor: ["orange", "green", "purple", "red"],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: {
            size: isMobile ? 11 : 14,
            weight: isMobile ? "bold" : "normal", // negrito apenas no mobile
          },
          color: "black", // cor preta em ambas versões
          boxWidth: isMobile ? 16 : 20,
          padding: isMobile ? 8 : 15,
        },
      },
    },
  };

  return (
    <div className="links-imc">
      <h3>Saiba mais sobre IMC</h3>

      <h4>Links úteis</h4>
      <ul className="lista-links">
        <li>
          👉 <a href="https://www.einstein.br/n/vida-saudavel/ectomorfo-mesomorfo-e-endomorfo-o-que-sao-os-biotipos-corporais" target="_blank" rel="noopener noreferrer">
            EinsteinBR - Biotipos Corporais
          </a>
        </li>
        <li>
          👉 <a href="https://drauziovarella.uol.com.br/doencas-e-sintomas/obesidade/" target="_blank" rel="noopener noreferrer">
            UOL - Tudo sobre a Obesidade
          </a>
        </li>
        <li>
          👉 <a href="https://www.hipertrofia.org/blog/2020/05/27/refeicoes-fitness-para-hipertrofia/" target="_blank" rel="noopener noreferrer">
            Blog - Receitas para Hipertrofia
          </a>
        </li>
      </ul>

      <h4 className="aviso-titulo">🚨 Aviso importante</h4>
      <p className="aviso-texto">
        O IMC é apenas um indicador. Para uma avaliação completa da saúde, consulte sempre um médico ou nutricionista.
      </p>

      <h4>Distribuição das categorias de IMC no Brasil</h4>
      {/* Container com classe específica para controlar altura e espaçamento */}
      <div className="grafico-barras">
        <Bar data={data} options={options} />
      </div>

      <h4>Média do IMC no Brasil em 2025</h4>
      <p>
        Em 2025, a média nacional de IMC gira em torno de <strong>26–27</strong>, indicando tendência de sobrepeso.  
        Estados como <strong>São Paulo, Santa Catarina e Paraná</strong> apresentam médias mais altas, enquanto <strong>Pará, Maranhão e Acre</strong> registram valores menores, mas ainda preocupantes.
      </p>
    </div>
  );
}

export default LinksIMC;